import { Document, Image, Page, pdf, Text, View } from '@react-pdf/renderer';
import { i18n } from '../../i18n/i18n';
import { IDs } from '../../helpers/IDs';
import { isValid as isValidEigenstrom } from '../../main/functions/validData';
import { lazyInject } from '../../services/inversify';
import * as Moment from 'moment';
import { parsePdfSub2 } from '../datenauswertung/generisch/helper';
import * as React from 'react';
import { SectionStyle } from '../../helpers/SectionStyle';
import { StructureService } from '../../services/structure_service';
import { WActionButton } from '../../core/elements/WActionButton';
import { WpdfText } from '../datenauswertung/pdf/WpdfText.';
import { WpdfView } from '../datenauswertung/pdf/WpdfView';
import { WSpinner } from '../../core/elements/spinner/WSpinner';


export interface ErneuerbareEnergienProps {
    data: any;
    standortTid: number;
}

export interface ErneuerbareEnergienState {
    isLoading: boolean;
}

export class ErneuerbareEnergien extends React.Component<ErneuerbareEnergienProps, ErneuerbareEnergienState> {

    constructor(props: any) {
        super(props);
        this.state = {
            isLoading: false
        };
    }

    @lazyInject(StructureService) private structureService: StructureService;

    private ignoreAtts: string[] = ['standort_tid'];

    getAnlagen(data: any): any[] {
        const typ: any = data || {};
        let entity: string = null;

        if (!Object.keys(typ).length) {
            return [];
        }

        switch (typ.anlagen_eigenstrom_typ_tid_orig) {
            case 1:
                entity = IDs.ENT_ANLAGEN_EIGENSTROM_WINDKRAFT;
                break;
            case 2:
                entity = IDs.ENT_ANLAGEN_EIGENSTROM_PHOTOVOLTAIK;
                break;
            case 3:
                entity = IDs.ENT_ANLAGEN_EIGENSTROM_KWK;
                break;
            case 4:
                entity = IDs.ENT_ANLAGEN_EIGENSTROM_SOLARTHERMIE;
                break;
            case 5:
                entity = IDs.ENT_ANLAGEN_EIGENSTROM_WAERMEPUMPEN;
                break;
            case 6:
                entity = IDs.ENT_ANLAGEN_EIGENSTROM_BIOMASSE;
                break;
        }

        return entity
            ? (this.props.data[entity] || []).filter((eigenstrom: any) =>
                (eigenstrom.standort_tid_orig || null) === (typ.standort_tid_orig || null) && isValidEigenstrom(eigenstrom, entity))
            : [];
    }

    getStructure(data: any): any {
        let entity: string = null;
        const typ: any = data || {};

        if (!Object.keys(typ).length) {
            return [];
        }

        switch (typ.anlagen_eigenstrom_typ_tid_orig) {
            case 1:
                entity = IDs.ENT_ANLAGEN_EIGENSTROM_WINDKRAFT;
                break;
            case 2:
                entity = IDs.ENT_ANLAGEN_EIGENSTROM_PHOTOVOLTAIK;
                break;
            case 3:
                entity = IDs.ENT_ANLAGEN_EIGENSTROM_KWK;
                break;
            case 4:
                entity = IDs.ENT_ANLAGEN_EIGENSTROM_SOLARTHERMIE;
                break;
            case 5:
                entity = IDs.ENT_ANLAGEN_EIGENSTROM_WAERMEPUMPEN;
                break;
            case 6:
                entity = IDs.ENT_ANLAGEN_EIGENSTROM_BIOMASSE;
                break;
        }
        return entity ? this.structureService.getStructureByKey(IDs.MOD_ETOOL, entity) : {};
    }

    getStyle(isPdf?: boolean): any {
        const Section: any = new SectionStyle();
        const backgroundColorSection: string = Section.getPropertyValue('--color-section-main');
        const backgroundColorSectionTable: string = Section.getPropertyValue('--color-section-table-background');
        const colorSection: string = Section.getPropertyValue('--color-button-text');

        return ({
            main: {
                maxWidth: 650,
                ...(!isPdf ? { margin: '0 0 0 20px' } : {}),
                display: 'flex',
                flexDirection: 'column'
            },
            header: {
                fontSize: '18pt',
                fontFamily: 'Helvetica-Bold',
                color: '#555',
                width: '100%',
                height: 85,
                top: 0,
                left: 0,
                padding: 0,
                position: 'relatitive',
                display: 'block'
            },
            headerImage: {
                width: 241,
                height: 40,
                top: 0,
                right: 0,
                position: 'absolute',
                display: 'inline-block'
            },
            headerText: {
                marginTop: -3
            },
            headerSubText: {
                fontSize: '16pt',
                color: backgroundColorSection || '#5e8bc2'
            },
            headerSubText2: {
                fontSize: '13pt',
                color: '#333',
                marginTop: 8
            },
            headerSubText3: {
                fontSize: '11pt',
                color: backgroundColorSection || '#6692c2'
            },
            footer: {
                fontSize: '8pt',
                right: 40,
                bottom: 15,
                left: 40,
                width: '100%',
                height: 'auto',
                padding: 0,
                position: 'absolute',
                display: 'block',
                boxSizing: 'border-box'
            },
            footerSeiten: {
                right: 0,
                position: 'absolute'
            },
            tabelle: {
                fontSize: '9pt',
                maxWidth: 650,
                margin: '15px 0 5px 0',
                border: '1pt solid white',
                display: 'flex',
                flexDirection: 'column',
                boxSizing: 'border-box'
            },
            row: {
                color: '#555',
                display: 'flex',
                flexDirection: 'row',
                boxSizing: 'border-box'
            },
            row_header: {
                ...(isPdf ? { fontFamily: 'Helvetica-Bold' } : {}),
                fontWeight: 'bold',
                // color: '#555',
                color: colorSection || '#555',
                marginTop: 9
            },
            row_standort: {
                ...(isPdf ? { fontFamily: 'Helvetica-Bold' } : {}),
                fontWeight: 'bold'
            },
            row_bezeichnung: {
                ...(isPdf ? { fontFamily: 'Helvetica-Bold' } : {}),
                fontWeight: 'bold',
                marginTop: 9
            },
            colgroup1: {
                display: 'flex',
                flexDirection: 'column',
                flexBasis: '100%'
            },
            col1: {
                // backgroundColor: '#ddd',
                backgroundColor: backgroundColorSectionTable || '#ddd',
                display: 'flex',
                flexDirection: 'column',
                flexBasis: '50%'
            },
            col1_header: {
                display: 'flex',
                flexDirection: 'column',
                flexBasis: '100%'
            },
            col1_standort: {
                display: 'flex',
                flexDirection: 'column',
                flexBasis: '100%'
            },
            col1_bezeichnung: {
                // backgroundColor: '#ddd',
                backgroundColor: backgroundColorSectionTable || '#ddd',
                display: 'flex',
                flexDirection: 'column',
                flexBasis: '100%'
            },
            col2: {
                // backgroundColor: '#ddd',
                backgroundColor: backgroundColorSectionTable || '#ddd',
                display: 'flex',
                flexDirection: 'column',
                flexBasis: '50%'
            },
            cell: {
                textAlign: 'left',
                padding: isPdf ? 2 : 4,
                borderTop: '1pt solid white',
                borderLeft: '1pt solid white',
                display: 'flex',
                flex: 1,
                justifyContent: 'flex-start',
                boxSizing: 'border-box'
            },
            cell_header: {
                // backgroundColor: '#bccae3'
                backgroundColor: backgroundColorSection || '#bccae3',
            },
            cell_standort: {
                paddingLeft: 1
            },
            cell1_bezeichnung: {
                textAlign: 'center',
                color: backgroundColorSection || '#6692c2',
                borderTop: 0,
                borderLeft: 0,
                justifyContent: 'center'
            },
            cell1: {
                ...(isPdf ? { fontFamily: 'Helvetica-Bold' } : {}),
                fontWeight: 'bold'
            },
            cell1_header: {
                borderTop: 0,
                borderLeft: 0
            },
            cell1_standort: {
            },
            cell2: {
                flexDirection: 'row'
            },
            ueberschrift: {
                fontSize: '11pt',
                ...(isPdf ? { fontFamily: 'Helvetica-Bold' } : {}),
                fontWeight: 'bold',
                color: '#555',
                maxWidth: '100%',
                ...(!isPdf ? { marginTop: 20 } : {}),
                paddingLeft: 3,
                display: 'flex',
                flexDirection: 'row',
                boxSizing: 'border-box'
            },
            actions: {
                backgroundColor: 'var(--color-wform-background)',
                maxWidth: '100%',
                top: 0,
                padding: 20,
                position: 'sticky',
                zIndex: 1,
                display: 'flex',
                flex: 1,
                flexDirection: 'row',
                justifyContent: 'flex-start',
                alignItems: 'center'
            },
            page: {
                padding: 40
            }
        });
    }

    getValue(value: number | string, atts: any): string {
        const euro: any = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });
        const float: any = new Intl.NumberFormat('de-DE', { minimumFractionDigits: 0, maximumFractionDigits: 2, useGrouping: true });
        const format: string = atts.FORMAT || null;
        const opts: any = atts.OPTS || null;
        const type: string = atts.TYPE || null;
        let valueString: any = value;

        if (Array.isArray(opts)) {
            valueString = (opts.find((opt: any) => opt.VALUE == value) || {}).TITEL || '';
        }

        switch (type) {
            case 'CHECKBOX':
                valueString = value ? i18n('Ja', 'sys') : i18n('Nein', 'sys');
                break;
            case 'DATE':
                valueString = value ? Moment(+value * 1000).format('DD.MM.YYYY') : '';
                break;
            case 'DOUBLE':
                valueString = typeof valueString === 'number'
                    ? (format === 'EURO' ? euro.format(valueString) : float.format(valueString))
                    : value;
                break;
            case 'PERCENT':
                valueString = typeof value === 'number' ? float.format(valueString) + ' %' : value;
                break;
            default:
                valueString = opts ? i18n(valueString || '', 'entity') : valueString;
                break;
        }
        return valueString;
    }

    async processPdf(pdfData: JSX.Element): Promise<void> {
        try {
            const blob = await pdf(pdfData).toBlob();
            const pdfString: string = URL.createObjectURL(blob);
            this.setState({ isLoading: false });
            const filename: string = (
                `${i18n('Erneuerbare Energien', 'sys')} ` +
                `[${(new Date()).toLocaleDateString('de-DE', { year: 'numeric', month: '2-digit', day: '2-digit' })}]` +
                '.pdf'
            );
            // const a = document.createElement('a');
            // a.target = '_blank';
            // a.title = filename;
            // a.href = pdfString;
            // a.download = filename;
            // document.body.appendChild(a);
            // a.click();
            // document.body.removeChild(a);
            saveAs(pdfString, filename);
        } catch (error) {
            // console.log('error: ', error);
        }
    }

    render(): JSX.Element {
        if (!this.props.data) {
            return <div>{i18n('Lade', 'sys')}...</div>;
        }
        const styles: any = this.getStyle();

        return <>
            <div style={styles.actions}>
                {this.renderPdfButton()}
            </div>
            <div style={styles.main}>
                {this.renderUeberschrift()}
                {this.renderStandorte()}
            </div>
            {this.state.isLoading && <WSpinner label='PDF...' />}
        </>;
    }

    renderAnlagen(data: any, isPdf?: boolean): JSX.Element[] {
        const styles: any = this.getStyle(isPdf);
        const anlagen: any[] = this.getAnlagen(data) || [];
        const atts: any = (this.getStructure(data) || {}).ATTS || [];
        const elements: JSX.Element[] = [];

        for (const anlage of anlagen) {
            const elementsAtts: JSX.Element[] = [];

            atts.forEach((element: any, index: number) => {
                const hidden: boolean = !!(
                    element.HIDDEN
                    && (+element.HIDDEN === 1 || element.HIDDEN === true || element.HIDDEN === 'YES')
                );
                const key: string = element.KEY || null;
                const name: string = i18n(element.NAME || null, 'entity');
                const type: string = element.TYPE || null;
                const value: string = this.getValue(anlage[key], element);

                if (this.ignoreAtts.indexOf(key) !== -1 || type === 'FILE' || type === 'TITEL' || hidden) {
                    return;
                } else if (key === 'name') {
                    elementsAtts.push(
                        <WpdfView key={`anlage-${index}`} style={{ ...styles.row, ...styles.row_bezeichnung }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.col1_bezeichnung }} pdf={isPdf}>
                                <WpdfView style={{ ...styles.cell, ...styles.cell1_bezeichnung }} pdf={isPdf}>
                                    <WpdfText pdf={isPdf}>{anlage[key]}&nbsp;</WpdfText>
                                </WpdfView>
                            </WpdfView>
                        </WpdfView>
                    );
                    return;
                }
                elementsAtts.push(
                    <React.Fragment key={`anlage_att-${index}`}>
                        <WpdfView style={{ ...styles.row }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.col1 }} pdf={isPdf}>
                                <WpdfView style={{ ...styles.cell, ...styles.cell1, borderLeft: 0 }} pdf={isPdf}>
                                    <WpdfText pdf={isPdf}>{name}</WpdfText>
                                </WpdfView>
                            </WpdfView>
                            <WpdfView style={{ ...styles.col2 }} pdf={isPdf}>
                                <WpdfView style={{ ...styles.cell, ...styles.cell2 }} pdf={isPdf}>
                                    <WpdfText pdf={isPdf}>{value}</WpdfText>
                                </WpdfView>
                            </WpdfView>
                        </WpdfView>
                    </React.Fragment>
                );
            });
            elements.push(
                <WpdfView key={`anlage-${anlage.tid}`} style={{ ...styles.row }} pdf={isPdf} nowrap>
                    <WpdfView style={{ ...styles.colgroup1 }} pdf={isPdf}>
                        {elementsAtts}
                    </WpdfView>
                </WpdfView>
            );
        }
        return elements;
    }

    renderEigenenergieTypen(standort: any, isPdf?: boolean): JSX.Element[] {
        const styles: any = this.getStyle(isPdf);
        const eigenenergie: any[] = (this.props.data[IDs.ENT_ANLAGEN_EIGENSTROM] || [])
            .filter((element: any) =>
                (element.standort_tid_orig || null) === standort.standort_tid_orig
                && element.anlagen_eigenstrom_typ_tid_orig
            );
        const eigenenergieTypenTids: number[] = eigenenergie.map((element: any) => element.anlagen_eigenstrom_typ_tid_orig);
        const eigenenergieTypen: any[] = (this.props.data[IDs.ENT_ANLAGEN_EIGENSTROM_TYPEN] || [])
            .filter((element: any) => eigenenergieTypenTids.indexOf(element.tid) !== -1);
        let index: number = 0;

        return eigenenergieTypen.map((typ: any) => {
            const anlage: any[] = eigenenergie.find((element: any) => element.anlagen_eigenstrom_typ_tid_orig === typ.tid);

            if (!(this.getAnlagen(anlage) || []).length) {
                return null;
            }

            return (
                <React.Fragment key={`eigenenergie_typ-${index}`}>
                    <WpdfView style={{ ...styles.row, ...styles.row_header }} pdf={isPdf} nowrap>
                        <WpdfView style={{ ...styles.col1_header }} pdf={isPdf}>
                            <WpdfView style={{ ...styles.cell, ...styles.cell_header, ...styles.cell1_header }} pdf={isPdf}>
                                <WpdfText pdf={isPdf}>{++index}. {i18n(typ.name, 'entity')}</WpdfText>
                            </WpdfView>
                        </WpdfView>
                    </WpdfView>
                    {this.renderAnlagen(anlage, isPdf)}
                </React.Fragment>
            );
        })
        .filter((item: any) => item !== null);
    }

    renderFooter(): JSX.Element {
        const styles: any = this.getStyle(true);

        return (
            <View style={styles.footer} fixed>
                <Text>{Moment().format('DD.MM.YYYY')}</Text>
                <View style={styles.footerSeiten}>
                    <Text
                        render={({ pageNumber, totalPages }) => {
                            if (totalPages > 1) {
                                return `${pageNumber}/${totalPages}`;
                            }
                        }}
                        fixed
                    />
                </View>
            </View>
        );
    }

    renderHeader(): JSX.Element {
        const header = require('../../img/logo_mittel2.png');
        const standort: string = typeof this.props.standortTid !== 'undefined'
            ? ((this.props.data[IDs.ENT_STANDORT] || [])
                .find((item: any) => item.tid === this.props.standortTid) || {}).name || null
            : null;
        const styles: any = this.getStyle(true);
        const unternehmen: string = ((this.props.data[IDs.ENT_UNTERNEHMENSDATEN] || [])[0] || {}).name
            || (this.props.data.RES_MAIN_LOAD_UNTERNEHMEN_SEL || {}).bezeichnung || null;

        return (
            <View style={styles.header} fixed>
                <Text style={styles.headerText}>E-Tool</Text>
                <Text style={styles.headerSubText}>
                    {parsePdfSub2(unternehmen, styles.headerSubText2)}
                </Text>
                <Text style={styles.headerSubText2}>
                    {i18n('Nutzung von Erneuerbaren Energien', 'sys')}
                </Text>
                <Text style={styles.headerSubText3}>
                    {standort ? parsePdfSub2(`${i18n('Standort', 'sys')}: ${standort}`, styles.headerSubText3) : i18n('Alle Standorte', 'sys')}
                </Text>
                <Image src={header} style={styles.headerImage} />
            </View>
        );
    }

    async renderPdf(): Promise<void> {
        const styles: any = this.getStyle(true);
        this.processPdf(
            <Document>
                <Page size='A4' orientation='portrait' style={styles.page}>
                    {this.renderHeader()}
                    {this.renderStandorte(true)}
                    {this.renderFooter()}
                </Page>
            </Document>
        );
    }

    renderPdfButton(): JSX.Element {
        return (
            <WActionButton
                label={i18n('PDF generieren', 'sys')}
                insideText={i18n('PDF generieren', 'sys')}
                key='pdf'
                action='pdf'
                onAction={() => this.setState({ isLoading: true }, this.renderPdf)}
            />
        );
    }

    renderStandorte(isPdf?: boolean): JSX.Element[] {
        const styles: any = this.getStyle(isPdf);
        const standortTypen: any = {};
        (this.props.data[IDs.ENT_STANDORT] || []).forEach((standort: any) => {
            standortTypen[standort.tid] = standort.standort_typ_tid_orig || null;
        });
        const standorte: any[] = (this.props.data[IDs.ENT_ANLAGEN_EIGENSTROM] || [])
            .filter((element: any) =>
                (!this.props.standortTid || (element.standort_tid_orig || null) === this.props.standortTid)
                && element.anlagen_eigenstrom_typ_tid_orig
            )
            .filter((value: any, index: number, arr: any) =>
                arr.map((item: any) => item.standort_tid_orig).indexOf(value.standort_tid_orig) === index
            )
            .sort((a: any, b: any) =>
                (+((+standortTypen[a.standort_tid_orig || null] || 0) !== 1) - +((+standortTypen[b.standort_tid_orig || null] || 0) !== 1))
                || (a.standort_tid > b.standort_tid)
            );

        return standorte.map((standort: any, index: number) => {
            const eigenenergieTypen: JSX.Element[] = this.renderEigenenergieTypen(standort, isPdf) || [];

            return eigenenergieTypen.length
                ? <WpdfView key={`standort-${index}`} style={{ ...styles.tabelle, ...(isPdf && !index ? { marginTop: 0 } : {}) }} pdf={isPdf}>
                    {!this.props.standortTid &&
                        <WpdfView style={{ ...styles.row, ...styles.row_standort }} pdf={isPdf} nowrap>
                            <WpdfView style={{ ...styles.col1_standort }} pdf={isPdf}>
                                <WpdfView style={{ ...styles.cell, ...styles.cell_standort, ...styles.cell1_standort }} pdf={isPdf}>
                                    <WpdfText pdf={isPdf}>{standort.standort_tid || null}</WpdfText>
                                </WpdfView>
                            </WpdfView>
                        </WpdfView>
                    }
                    {eigenenergieTypen}
                </WpdfView>
                : null;
        });
    }

    renderUeberschrift(isPdf?: boolean): JSX.Element {
        const styles: any = this.getStyle(isPdf);

        return (
            <WpdfView style={styles.ueberschrift} pdf={isPdf}>
                <WpdfText pdf={isPdf}>
                    {i18n('Nutzung von Erneuerbaren Energien', 'sys')}
                </WpdfText>
            </WpdfView>
        );
    }
}
